import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function AdminLayout({ children, title }) {
  const { isAdmin } = useAuth();
  const location = useLocation();

  if (!isAdmin) {
    return (
      <div className="container">
        <div className="empty-state">
          <div className="icon">🔒</div>
          <h2>Admin Access Required</h2>
          <p>Please <Link to="/login">sign in</Link> with an admin account.</p>
        </div>
      </div>
    );
  }

  const links = [
    { to: '/admin', label: '📊 Dashboard' },
    { to: '/admin/products', label: '📦 Products' },
    { to: '/admin/inventory', label: '📋 Inventory' },
    { to: '/admin/categories', label: '🏷️ Categories' },
    { to: '/admin/orders',  label: '🛍️ Orders' },
    { to: '/admin/returns', label: '↩️ Returns' },
    { to: '/admin/coupons', label: '🏷️ Coupons' },
    { to: '/admin/customers', label: '👥 Customers' },
    { to: '/admin/blog', label: '📝 Blog' },
    { to: '/admin/subscribers', label: '📧 Subscribers' },
  ];

  return (
    <div className="admin-layout">
      <nav className="admin-sidebar">
        {links.map(l => (
          <Link key={l.to} to={l.to} className={location.pathname === l.to ? 'active' : ''}>
            {l.label}
          </Link>
        ))}
        <Link to="/" style={{ marginTop: 'auto', opacity: 0.7 }}>← Back to Store</Link>
      </nav>
      <div className="admin-content">
        {title && <h1 style={{ marginBottom: 20 }}>{title}</h1>}
        {children}
      </div>
    </div>
  );
}
